// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';
// @ts-expect-error
import {useWatch} from 'react-hook-form';

import type {FormFieldSchema} from '../../../../core/nutshell-fields/types';

import {getPageFieldDragOverlayReactNode} from '../editor/preview/get-page-field-components';
import {findFieldLocationByRowKey} from '../helpers';
import {FieldCardPreview} from '../sidebar/blocks-and-design/content-blocks/field-card-preview';
import type {DraggableCardData} from '../sidebar/blocks-and-design/content-blocks/types';

import {FormSortableDragOverlayPreview} from './form-sortable-drag-overlay-preview';

interface Props {
    sidebarDragCard: DraggableCardData | null;
    reorderingFieldKey: string | null;
    sortableOverlayFontFamily: string | undefined;
    control: Control;
    watch: Watch;
    formSchema: FormFieldSchema | null | undefined;
}

export function FormEditorDragOverlayContent(props: Props) {
    const pages = useWatch({control: props.control, name: 'pages'});

    if (props.sidebarDragCard) {
        return (
            <FieldCardPreview
                Icon={props.sidebarDragCard.Icon}
                inDragOverlay={true}
                label={props.sidebarDragCard.label}
            />
        );
    }

    if (props.reorderingFieldKey && props.formSchema) {
        const location = findFieldLocationByRowKey(pages, props.reorderingFieldKey);
        const overlayBody = location
            ? getPageFieldDragOverlayReactNode({
                  fieldPathPrefix: `pages.${location.pageIndex}.fields`,
                  pageIndex: location.pageIndex,
                  index: location.fieldIndex,
                  field: location.field,
                  formSchema: props.formSchema,
                  watch: props.watch,
                  control: props.control,
              })
            : null;

        return (
            <FormSortableDragOverlayPreview fontFamily={props.sortableOverlayFontFamily}>
                {overlayBody}
            </FormSortableDragOverlayPreview>
        );
    }

    return null;
}
